export default __webpack_public_path__ + "static/media/aa13de5cd56c794b3f0d328531e42ef2.5286bf74.svg";